import { TOKEN_COOKIE } from "./constants";

const HUNDRED_YEARS_MS = 100 * 365.25 * 24 * 60 * 60 * 1000;

function setCookie(name: string, value: string) {
  const expires = new Date(Date.now() + HUNDRED_YEARS_MS).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function removeCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

export function setAccessToken(token: string) {
  setCookie(TOKEN_COOKIE, token);
}

export function getAccessToken(): string | null {
  return getCookie(TOKEN_COOKIE);
}

export function clearAccessToken() {
  removeCookie(TOKEN_COOKIE);
}

export function isAuthenticated(): boolean {
  return getAccessToken() !== null;
}
